export default __webpack_public_path__ + "static/media/x.64bae9a3.svg";